<div class="page-scroll-nav hide">
    <nav class="scroll-init color2-bg">
        <ul class="no-list-style">
            <li><a class="act-scrlink tolt" href="#sec1" data-microtip-position="left" data-tooltip="Our story"><i class="fal fa-building"></i></a></li>
            <li><a href="#sec2" class="tolt" data-microtip-position="left" data-tooltip="Promo Video"><i class="fal fa-video"></i></a></li>
            <li><a href="#sec3" class="tolt" data-microtip-position="left" data-tooltip="Our team"><i class="far fa-users-crown"></i></a></li>
            <li><a href="#sec4" class="tolt" data-microtip-position="left" data-tooltip="Why us"><i class="fal fa-user-astronaut"></i></a></li>
            <li><a href="#sec5" class="tolt" data-microtip-position="left" data-tooltip="Testimonials"><i class="fal fa-comment-alt-smile"></i></a></li>
        </ul>
    </nav>
</div>
<!--  section  -->
<section class="parallax-section single-par" data-scrollax-parent="true">
    <div class="bg par-elem" style="background-image: url('../../assets/images/bg/2.jpg'); translate:'30%'"></div>
    <div class="overlay op7"></div>
    <div class="container">
        <div class="section-title center-align big-title">
            <h2><span>About Our Company</span></h2>
            <span class="section-separator"></span>
            <div class="breadcrumbs fl-wrap"><a href="/">Home</a><span>About us</span></div>
        </div>
    </div>
    <div class="header-sec-link">
        <a href="#sec1" class="custom-scroll-link"><i class="fal fa-angle-double-down"></i></a>
    </div>
</section>
<!--  section  end-->
<section id="sec1" data-scrollax-parent="true">
    <div class="container">
        <div class="section-title">
            <h2> About Us</h2>
            <div class="section-subtitle">who we are</div>
            <span class="section-separator"></span>
            <p>Explore some of the best tips from around the city from our partners and friends.</p>
        </div>
        <!--about-wrap -->
        <div class="about-wrap">
            <div class="row">
                <div class="col-md-6 hide">
                    <div class="list-single-main-media fl-wrap" style="box-shadow: 0 9px 26px rgba(58, 87, 135, 0.2);">
                        <img src="../../assets/images/all/1.jpg" class="respimg" alt="Business in Maharashtra office" loading="lazy" decoding="async">
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="ab_text">
                        <div class="ab_text-title fl-wrap">
                            <h3>Our Awesome <span>Story</span></h3>
                            <span class="section-separator fl-sec-sep"></span>
                        </div>
                        <p>`Business in Maharashtra` was launched because we saw the need for a place where the local community within a city could come together, meet, trade and help each other in many ways. Community members can come here to find an apartment to live in, sell their Industry Product, old car, bike, music system, laptop or furniture, Land, agriculture product, promote their all business.</p>

                        <p>The `Business in Maharashtra` Provides a common platform for the Maharashtra (Indian) and online International business community. Being India's Developing <b>online B2B portal and e-marketplace</b>, we are offering comprehensive business solutions to the Global community. Our portal is an ideal forum for buyers and sellers across the world to interact and conduct Online B2B business Easily and effectively. So Browse our indian business portal and get listed here FREE and take a trail demo for registration.</p>

                        <p>With an unmatched expertize in data acquisition and online promotion, Business in Maharashtra subsumes numerous company profiles and product catalogs under thousand's of different product categories and sub-categories in its India B2B Portal. It is well promoted on all major search engines. Our business portal from India is maintained and promoted by "Experienced Management Team" of Excellent Web Promoters &amp; SEO's. Today we have reached a database of various registered users, and the organisation is still growing with a considerable amount of new users joining/registering everyday.</p>

                        <p>Our Business in Maharashtra  portal is a <b>Online B2B Portal and e-marketplace</b>, offering comprehensive business solutions to the global community through its wide array of online services, India Trade Directory services and facilitation of online trade promotional events. This India Trade Directory and Indian B2B portal is an ideal forum for buyers and sellers across the globe to interact and conduct business on dynamic online network.</p>

                        <p>The <b>B2B portal of Maharashtra</b> has a massive database of buyers, sellers for your business. We generate trade leads and promote your business profile through e-catalog &amp; explore new horizons for your business</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- about-wrap end  -->
    </div>
</section>
<!--section end-->

<!--section  -->
<section class="parallax-section video-section" data-scrollax-parent="true" id="sec2">
    <div class="bg par-elem" style="background-image: url('../../assets/images/bg/about.jpg'); translate:'30%'"></div>
    <div class="overlay op7"></div>
    <!--container-->
    <div class="container">
        <div class="video_section-title fl-wrap">
            <h4>Our Journey</h4>
            <h2>Get ready to start your exciting journey. 
                <br> Our agency will lead you through the amazing digital world</h2>
        </div>
    </div>
</section>
<!--section end-->
<!--section  -->
<section class="parallax-section" data-scrollax-parent="true" id="sec4">
    <div class="bg par-elem "  style="background-image: url('../../assets/images/bg/4.jpg'); translate:'30%'"></div>
    <div class="overlay op7"></div>
    <!--container-->
    <div class="container">
        <div class="section-title center-align big-title">
            <h2><span>Why Choose Us</span></h2>
            <span class="section-separator"></span>
        </div>
    </div>
</section>
<!--section end-->
<!--section  -->
<section class="gray-bg absolute-wrap_section">
    <div class="container">
        <div class="absolute-wrap fl-wrap">
            <!-- features-box-container -->
            <div class="features-box-container fl-wrap">
                <div class="row">
                    <!--features-box -->
                    <div class="col-md-4">
                        <div class="features-box">
                            <div class="time-line-icon">
                                <i class="fal fa-headset"></i>
                            </div>
                            <h3>24 Hours Support</h3>
                        </div>
                    </div>
                    <!-- features-box end  -->
                    <!--features-box -->
                    <div class="col-md-4">
                        <div class="features-box gray-bg">
                            <div class="time-line-icon">
                                <i class="fal fa-users-cog"></i>
                            </div>
                            <h3>Profile Panel</h3>
                        </div>
                    </div>
                    <!-- features-box end  -->
                    <!--features-box -->
                    <div class="col-md-4">
                        <div class="features-box ">
                            <div class="time-line-icon">
                                <i class="fal fa-mobile"></i>
                            </div>
                            <h3>Mobile Friendly</h3>
                        </div>
                    </div>
                    <!-- features-box end  -->
                </div>
            </div>
            <!-- features-box-container end  -->
        </div>
        <div class="section-separator"></div>
    </div>
</section>
<!--section end-->
<!--section  -->
<section id="sec5" class="hide">
    <div class="container">
        <div class="section-title">
            <h2> Testimonilas</h2>
            <div class="section-subtitle">Clients Reviews</div>
            <span class="section-separator"></span>
            <p>Explore some of the best tips from around the city from our partners and friends.</p>
        </div>
    </div>
    <div class="clearfix"></div>
   
</section>
<!--section end-->